import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-boolean-view',
  templateUrl: './boolean-view.component.html',
  styleUrls: ['./boolean-view.component.scss']
})
export class BooleanViewComponent implements OnInit {
  @Input() value = false;
  @Input() text = '';
  @Input() width = '';
  @Input() height = '';
  @Input() trueColor = '#137B25';
  @Input() falseColor = '#FF3C00';
  @Input() trueTextColor = '#ffffff';
  @Input() falseTextColor = '#ffffff';
  @Input() borderColor = '#FFFFFF'

  ngOnInit(): void { }
}
